import React, { useState, useEffect } from 'react';


import Navbar from "./partials/Navbar";
import FooterDark from './partials/FooterDark';

import api from "./services/api";

export default function NextSteps (props) {

    const [hasTopographer, setHasTopographer] = React.useState(false);
    const [agreedToTerms, setAgreedToTerms] = React.useState(false);

    const canPay = hasTopographer && agreedToTerms;


    const handleCheckout = async () => {
          try {
            const response = await api.post("/checkoutmd", {
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: "new-subscription" }] })
            });
        
            const jsonResponse = response.data;
        
            if (jsonResponse.url) {
              window.location.assign(jsonResponse.url);
            }
        
          } catch (err) {
            console.error(err.message);
          }
        };


    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])


    const[getStartedButton, setGetStartedButton]=useState(false)
 
    let backgroundStyleWhite = {
        background: "#FFF",
        padding: '0 0 0 0',
    }

    let buttonStyleTrue = {
        borderRadius: '5px',
        margin: '5px auto',
        padding: '10px 20px',
        border: '1px solid #007bff',
        color: '#FFF',
        background: '#007bff',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        cursor: 'pointer',
    }
    
    let buyButtonStyleTrue = {
        border: '1px solid #007bff',
        color: '#FFF',
        borderRadius: '10px',
        background: "#007bff",
        margin: '10px 5px 0px 5px',
        padding: '10px 20px',
        cursor: 'pointer',
        width: '340px',
        textAlign: 'center',
        textDecoration: 'none',
        // position: 'fixed',
        // zIndex: '3',
      }
      

    let pStyle = {
        margin: '0 0 4px 0',
        fontSize: "20px",
    }


    const checkboxRow = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '14px',
    fontSize: '15px',
    lineHeight: '1.4',
    cursor: 'pointer'
    };

    const checkboxBox = (checked) => ({
        width: '20px',
        height: '20px',
        borderRadius: '6px',
        border: checked ? '2px solid #007bff' : '2px solid #cfd3d8',
        backgroundColor: checked ? '#007bff' : '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.15s ease'
    });


    return(
        <div style={backgroundStyleWhite}>
            <Navbar/>
            <div
                style={{
                    width: "100%",
                    maxWidth: "800px",
                    margin: "50px auto",
                    textAlign: "center",
                }}
                >
                {/* VIDEO */}
                <div
                    style={{
                    position: "relative",
                    width: "100%",
                    paddingTop: "56.25%", // 16:9 aspect ratio
                    }}
                >

                    <iframe
                    src="https://player.vimeo.com/video/1160394970?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    title="introductionMovie"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        borderRadius: "12px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                        backgroundColor: "#000",
                    }}
                    />
                </div>
                <div style={{
                    border: '1px solid #e6e8eb',
                    borderRadius: '12px',
                    padding: '16px',
                    margin: '40px 0px 20px 0px',
                    background: '#fafafa'
                }}>

                    {/* Topographer checkbox */}
                    <label style={checkboxRow}>
                        <input
                            type="checkbox"
                            checked={hasTopographer}
                            onChange={(e) => setHasTopographer(e.target.checked)}
                            style={{ display: 'none' }}
                        />

                        <div style={checkboxBox(hasTopographer)}>
                            {hasTopographer && (
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                    <path
                                        d="M1 5L4.5 8.5L11 1.5"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            )}
                        </div>

                        <span>
                            I have a topographer that measures HOA and spherical aberration
                        </span>
                    </label>

                    {/* Terms checkbox */}
                    <label style={checkboxRow}>
                        <input
                            type="checkbox"
                            checked={agreedToTerms}
                            onChange={(e) => setAgreedToTerms(e.target.checked)}
                            style={{ display: 'none' }}
                        />

                        <div style={checkboxBox(agreedToTerms)}>
                            {agreedToTerms && (
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                    <path
                                        d="M1 5L4.5 8.5L11 1.5"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            )}
                        </div>

                        <span>
                            I have read and agree to the{" "}
                            <a
                                href="/termsofuse"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: '#007bff',
                                    textDecoration: 'none',
                                    fontWeight: 500
                                }}
                            >
                                Terms of Use
                            </a>
                        </span>
                    </label>
                </div>

                <div
                    onClick={canPay ? handleCheckout : undefined}
                    style={{
                        background: canPay
                            ? 'linear-gradient(180deg, #007bff, #4f46e5)'
                            : '#e4e6eb',
                        color: canPay ? '#fff' : '#9aa0a6',
                        padding: '14px',
                        borderRadius: '12px',
                        textAlign: 'center',
                        fontWeight: 600,
                        fontSize: '16px',
                        cursor: canPay ? 'pointer' : 'not-allowed',
                        transition: 'all 0.2s ease',
                        userSelect: 'none'
                    }}
                >
                    Purchase
                </div>


                {/* BUTTON */}

            </div>
            

            <FooterDark/>
        </div>
    )
} 